(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["decolab-product-coupon"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('decolab-product-coupon')) {
    customElements.define('decolab-product-coupon', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort(); this.abort = new AbortController();
        this.querySelector('[data-copy-coupon]')?.addEventListener('click', async () => {
          const status = this.querySelector('[data-copy-status]');
          try {
            if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
            await navigator.clipboard.writeText('BEMVINDO10');
            this.querySelector('[data-copy-label]').textContent = status.dataset.success;
            status.textContent = status.dataset.success;
          } catch { status.textContent = status.dataset.error; }
        }, {signal:this.abort.signal});
        document.addEventListener('variant:update', event => {
          if (String(event.detail?.data?.productId) !== this.dataset.productId) return;
          const replacement = event.detail.data.html?.querySelector('decolab-product-coupon');
          if (replacement) this.hidden = replacement.hidden;
        }, {signal:this.abort.signal});
      }
      disconnectedCallback() {this.abort?.abort();}
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["decolab-variant-card"] && !Shopify.designMode) return;
  try {
    if (!window.decolabVariantCardInitialized) {
    window.decolabVariantCardInitialized = true;

    /*
     * Controle de quantidade.
     */
    document.addEventListener('click', (event) => {
      const button = event.target.closest(
        '[data-decolab-quantity-action]'
      );

      if (!button || button.disabled) return;

      const form = button.closest(
        '.decolab-variant-card__form'
      );

      const input = form?.querySelector(
        '[data-decolab-quantity-input]'
      );

      if (!input) return;

      const currentValue =
        Number.parseInt(input.value, 10) || 1;

      const action =
        button.dataset.decolabQuantityAction;

      if (action === 'increase') {
        input.value = currentValue + 1;
      }

      if (action === 'decrease') {
        input.value = Math.max(
          1,
          currentValue - 1
        );
      }

      input.dispatchEvent(
        new Event('change', {
          bubbles: true
        })
      );
    });

    /*
     * Coloca as avaliações do BK Reviews no local correto
     * dentro dos cartões personalizados de variantes.
     */
    function positionVariantReviews() {
      document
        .querySelectorAll('.decolab-variant-card')
        .forEach((card) => {
          const target = card.querySelector(
            '[data-decolab-review-target]'
          );

          const productItem = card.closest(
            '.product-grid__item'
          );

          if (!target || !productItem) return;

          const review = productItem.querySelector(
            '.collection-star-section.bk-reviews'
          );

          if (!review) return;

          /*
           * A avaliação já está na posição correta.
           */
          if (target.contains(review)) return;

          review.classList.add(
            'decolab-variant-card__bk-reviews'
          );

          target.appendChild(review);
        });
    }

    let reviewAnimationFrame;

    function scheduleVariantReviews() {
      cancelAnimationFrame(
        reviewAnimationFrame
      );

      reviewAnimationFrame =
        requestAnimationFrame(() => {
          positionVariantReviews();
        });
    }

    function initializeVariantReviews() {
      positionVariantReviews();

      /*
       * O BK Reviews normalmente carrega depois do restante
       * da página. O observador espera a inserção das estrelas.
       */
      const observer = new MutationObserver(
        scheduleVariantReviews
      );

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });

      document.addEventListener(
        'shopify:section:load',
        scheduleVariantReviews
      );
    }

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        initializeVariantReviews,
        { once: true }
      );
    } else {
      initializeVariantReviews();
    }
  }
  } catch(e) { console.error(e); }
})();

})();
